<template>
  <div class="uploadAttachment">
    <div class="title">
      <span>相关凭证</span>
      <!-- <span class="content">选择您要上传的照片</span> -->
    </div>
    <div class="uploadBox">
      <van-uploader
        :after-read="afterRead"
        multiple
        accept="image/*"
        preview-image
        v-model="files"
        preview-full-image
        preview-size="72px"
        :before-delete="handleDelete"
        :max-count="3"
        @delete="deleteFile"
      >
      </van-uploader>
    </div>
  </div>
</template>

<script>
import api from '../../../service/modules/instantMessaging'
    
    const HTTPS = 'https://'
    
    export default {
        props: ['fileBizType', 'sourceId', 'localFiles'], // sourceId为退货详情的basicid
        data () {
            return {
                files: [], // 待上传的文件
                uploadFile: [], // 上传成功后的文件,
                uploadTemp: [],
                temporaryFiles: [],
                uploadFileUrl: [],
                cos: '',
                cosArg: '',
                postData: [],
                tempFile: [],
            };
        },
        watch: {
            localFiles (newVal, oldVal) {
                if (newVal) {
                    this.files = newVal
                }
            }
        },
        created () {
            if (this.localFiles) {
                this.files = this.localFiles
            }
            this.getSession()
        },
        mounted() {
        },
        methods: {
            getSession() {
                api.cosGetFederationToken().then(res => {
                    if (res.ret === 0) {
                        this.cosArg = res.data
                        console.log('cosArg----------', this.cosArg)
                        this.cos = new COS({
                            getAuthorization: function (options, callback) {
                                callback({
                                    TmpSecretId: res.data && res.data.tmpSecretId,
                                    TmpSecretKey: res.data && res.data.tmpSecretKey,
                                    XCosSecurityToken: res.data && res.data.sessionToken,
                                    ExpiredTime: res.data.expiredTime
                                });
                            }
                        })
                    }
                })
            },
            deleteFile () {
                console.log('删除11111111', this.files)
                if (this.$route.fullPath == '/refund/secondRefund') {
                    localStorage.setItem('fileCache', JSON.stringify(this.files))
                }
            },
            // 删除预览文件
            handleDelete (files) {
                this.$store.commit('refund/delTempFiles', files)
                if (files instanceof Object) {
                    if (files.hasOwnProperty('file')) {
                        // 删除源文件
                        let imgItem;
                        this.temporaryFiles.forEach(element => {
                            if (element.hasOwnProperty(files.file.lastModified)) {
                                imgItem = element[files.file.lastModified];
                            }
                        });

                        if (imgItem) {
                            this.uploadFile = this.uploadFile.filter(item => {
                                return item !== imgItem;
                            });
                        }
                    }
                    this.$emit('fileuploadData', this.uploadFile);
                    // this.$dispatch("fileUploadData", [...this.uploadFile]);
                    return true;
                }
            },
            // 文件读取完成
            afterRead (file) {
                this.tempFile = []
                if (Array.isArray(file)) {

                    // 多图
                    for (let index = 0; index < file.length; index++) {
                        this.postData.push(file[index])
                        this.tempFile.push(file[index])
                    }
                } else {
                    // 单图
                    this.postData.push(file)
                    this.tempFile.push(file)
                }
                this.handleUploadFile()
            },
            // 上传
            handleUploadFile (data, files) {
                this.$Toast.loading({
                    duration: 0,
                    message: '文件上传中...',
                    forbidClick: true
                });
                console.log('uploadTemp-------', this.uploadTemp)
                for (let i = 0; i < this.tempFile.length; i++) {
                    const cosKey = `${this.cosArg.tmpSecretKey}/${new Date().getTime()}/${this.tempFile[i].file.name}`
                    this.cos.putObject({
                        Bucket: this.cosArg.bucket,
                        Region: this.cosArg.region,
                        Key: cosKey,
                        Body: this.tempFile[i].file,
                        onHashProgress: function (progressData) {
                            console.log('校验中', JSON.stringify(progressData));
                        },
                        onProgress: function (progressData) {
                            console.log('上传中', JSON.stringify(progressData));
                        }
                    }, (err, res) => {
                        console.log('上传-------', err);
                        if (!err) {
                            this.uploadTemp.push(HTTPS + res.Location)
                            this.$emit('fileuploadData', this.uploadTemp)
                            this.$Toast.clear()
                            console.log('this.uploadTemp:', this.uploadTemp)
                        }
                    })
                }


            }
        },
        destroyed () {
            this.$Toast.clear();
        }
    };
</script>

<style lang="less" scoped>
.uploadAttachment {
  width: 100%;
  .title {
    font-size: 14px;
    color: #666666;
    font-weight: 400;
    .content {
      font-size: 12px;
      color: #aaa;
    }
    // height: 60px;
    margin-bottom: 12px;
  }
  /deep/.uploadBox {
    margin-bottom: -20px;
    position: relative;
    .my-delicon {
      width: 18px;
      height: 18px;
      position:absolute;
      right: 0;
      top: 0;
    }
    .van-uploader__upload {
      background-color: white;
      border: 1px dashed #cdcdce;
    }
    .van-uploader__preview-delete::before {
      opacity: 0;
      background-size: 100% 100%;
    //   background-image: url("../../../../assets/refund/ic_delete.png");
    //   background-image: url("@/assets/refund/ic_delete.png");
    }
    .van-uploader__preview::after {
      content: '';
      pointer-events: none;
      position: absolute;
      right: 0;
      top: -6px;
      width: 18px;
      height: 18px;
    //   background-image: url('../../../../assets/refund/ic_delete.png');
      background-size: 100% 100%;
    }
  }
}
</style>
<style lang="less" scoped>
.uploadAttachment {
  .uploadBox {
    .van-uploader {
      .van-uploader__wrapper {
        .van-uploader__upload {
          border: 1px solid red !important;
        }
      }
    }
  }
}
</style>
